import LoadingButton from '@mui/lab/LoadingButton';

export const SubmitButton = ({text, handleSubmit, loading, disabled}) => (
    <LoadingButton
        sx={{mt: 3}}
        variant="contained"
        fullWidth
        loading={loading}
        onClick={handleSubmit}
        disabled={disabled}
    >
        {text}
    </LoadingButton>
);
